import { ApiService } from "./api.service";
export default class ReviewTBAService extends ApiService {
  namespace = "reviewToBeApproved";
  DOMAIN = -66;
  name = "Review To Be Paid";
  template = "defaultTemplate";
  Width = 850;
  favicon = "SaveTick";
  constructor() {
    super("ap-tbas");
  }
}
